module.exports = "/**\n * Function to create an optimized svg url\n */\n/**\n * Replace `$search` with `$replace` in `$string`\n * @author Hugo Giraudel\n * @param {String} $string - Initial string\n * @param {String} $search - Substring to replace\n * @param {String} $replace ('') - New value\n * @return {String} - Updated string\n */\n.supporting-claim-documents {\n  margin-bottom: 1.25rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/liability/steps/malpractice/malpractice-screen.component.scss
// module id = 1433
// module chunks = 0